import { render, staticRenderFns } from "./IconReviewsStar.vue?vue&type=template&id=5d45b930&scoped=true&"
import script from "./IconReviewsStar.vue?vue&type=script&lang=js&"
export * from "./IconReviewsStar.vue?vue&type=script&lang=js&"
import style0 from "./IconReviewsStar.vue?vue&type=style&index=0&id=5d45b930&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d45b930",
  null
  
)

export default component.exports